import React, { useState } from 'react'
import { Tabs, Tab } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import { CenteredLayout } from './shared/CenteredLayout'
import Details from '../components/serviceConfiguration/Details'
import Products from '../components/serviceConfiguration/products/Products'
import AccessLevels from '../components/serviceConfiguration/accessLevels/AccessLevels'
import { ContentTitle } from '../components/shared/ContentTitle'

const useStyles = makeStyles(() => ({
    tabs: {
        border: '1px solid #ccc',
        backgroundColor: '#fff',
        marginBottom: '10px',
    },
    bodySection: {
        marginBottom: '30px',
    },
}))

export function ServiceConfigurationPage() {
    const classes = useStyles()
    const tabValues = {
        DETAILS: 0,
        PRODUCTS: 1,
        ACCESS_LEVELS: 2,
    }

    const [tabValue, setTabValue] = useState(tabValues.DETAILS)

    const handleTabChange = (event, newValue) => {
        setTabValue(newValue)
    }

    const TabView = () => {
        switch (tabValue) {
            case tabValues.DETAILS:
                return <Details />
            case tabValues.PRODUCTS:
                return <Products />
            case tabValues.ACCESS_LEVELS:
                return <AccessLevels />
            default:
                return <Details />
        }
    }

    return (
        <CenteredLayout>
            <ContentTitle pageTitle={'Service'} />

            <div
                style={{ justifyContent: 'center' }}
                className={classes.topBarSection}>
                <Tabs
                    value={tabValue}
                    onChange={handleTabChange}
                    indicatorColor='secondary'
                    textColor='secondary'
                    variant='fullWidth'
                    className={classes.tabs}>
                    <Tab label='Details' />
                    <Tab label='Products' />
                    <Tab label='Access Levels' />
                </Tabs>
            </div>
            <div className={classes.bodySection}>
                <TabView />
            </div>
        </CenteredLayout>
    )
}
